import { combineReducers } from '@reduxjs/toolkit';
import { reducers } from '@/store';

export const rootReducer = combineReducers(reducers);
